<div id="getServingJsServers"
     class="table-header margin-top-30">
  <span>Serving Join Servers</span>
  <div class="table-filter">
    <form class="form-inline">
      <select id="table-join-search"
              [(ngModel)]="optionServingJoinServerSearch"
              name="optionServingJoinServerSearch"
              class="table-filter-search form-control"
              (change)='onOptionServingJoinServerSearchChanged($event)'>
        <option selected="selected">Search Type</option>
        <option>JoinEUI</option>
        <option>Name</option>
      </select>
      <input type="text"
             class="form-control"
             name="inputKeywordServingJoinServerSearch"
             id="input-serving-search"
             aria-describedby="search"
             placeholder="Search"
             [(ngModel)]="inputKeywordServingJoinServerSearch"
             (keyup)="onKeywordSearch($event)">
      <i class="fa fa-search text-tooltip"
         title-popup="Search" aria-hidden="true" (click)="refreshServingJoinServers()">
      </i>
    </form>
  </div>
  <div class="position-relative table-icon action">
    <i class="fa fa-list transition text-tooltip"
       aria-hidden="true"
       title-popup="List">
    </i>
    <div class="tooltip-actions width-140">
      <div class="arrow-up"></div>
      <ul>
        <li>
          <label col-id="0"
                 table-name="serving-join-servers-list"
                 class="checked">JoinEUI
          </label>
        </li>
        <li>
          <label col-id="1"
                 table-name="serving-join-servers-list"
                 class="checked">Name
          </label>
        </li>
        <li>
          <label col-id="2"
                 table-name="serving-join-servers-list"
                 class="checked">Processed VNS
          </label>
        </li>
        <li>
          <label col-id="3"
                 table-name="serving-join-servers-list"
                 class="checked">Processed HNS
          </label>
        </li>
      </ul>
    </div>
  </div>
  <div class="table-icon refresh"
       (click)="refreshServingJoinServers()">
    <i class="fa fa-refresh" [ngClass]="(servingJoinServersRefreshing)?'fa fa-spinner fa-spin':'fa fa-refresh'"
       aria-hidden="true"
       title-popup="Refresh"></i>
  </div>
  <div *ngIf="isAdmin && canAddServingJoinServers && !renderNsGroup" class="table-icon plus">
    <i class="fa fa-plus transition text-tooltip"
       aria-hidden="true"
       title-popup="Add"
       (click)="createActivationAgreement(name,netIds,virtId,protocolVersion)"></i>
  </div>
</div>
<div class="table-panel">
  <table class="table-roaming-partners table table-striped table-responsive"
         id="serving-join-servers-list">
    <thead>
    <tr>
      <th>JoinEUI</th>
      <th>Name</th>
      <th class="text-tooltip"
          title-popup="Number of HomeNSAns that returned this NS as HomeNS">Processed HomeNSReq</th>
      <th class="text-tooltip"
          title-popup="“Number of JoinReq sent by this NS">Processed JoinReq</th>
      <th class="text-tooltip"
          title-popup="Number of rejected JoinReq sent by this NS">Rejected JoinReq</th>
      <th *ngIf="isAdmin && !renderNsGroup"></th>
    </tr>
    </thead>
    <tbody>

    <tr *ngFor="let item of listServingJoinServers | paginate: configPagerServingJoinServers">
      <td *ngIf="isAdmin" class="servingJoinServers-joinEUI-td"><a [routerLink]="['/join',item.virtId]">{{item.joinEUIs | cidr}}</a></td>
      <td *ngIf="!isAdmin" class="servingJoinServers-joinEUI-td">{{item.joinEUIs | cidr}}</td>
      <td *ngIf="isAdmin"><a [routerLink]="['/join',item.virtId]">{{item.name}}</a></td>
      <td *ngIf="!isAdmin">{{item.name}}</td>
      <td>{{item.vnsMessageCount}} {{item.hasError ? '(!)' : ''}}</td>
      <td>{{item.hnsMessageCount}} {{item.hasError ? '(!)' : ''}}</td>
      <td>{{item.hnsRejectCount}} {{item.hasError ? '(!)' : ''}}</td>
      <td *ngIf="isAdmin && !renderNsGroup">
        <ng-template #actionsPopup>
          <p *ngIf="protocolVersion != '1.0'" class="popup-text"
             (click)="editActivationAgreement(virtId, item.virtId, name, item.name, netIds, item.joinEUIs)">
            Edit</p>
          <p class="popup-text" (click)="deleteModal.show()">Delete</p>
        </ng-template>
        <button class="view-detail-btn"
                [popover]="actionsPopup"
                placement="left"
                triggers="click"
                [outsideClick]="true"
                container="body">...</button>
          <app-delete-modal #deleteModal
                            text="Serving Join Server {{item.name}} will be deleted."
                            jsId="{{item.virtId}}"
                            nsId="{{virtId}}"
                            deleteType="activationAgreement"></app-delete-modal>
      </td>
    </tr>
    </tbody>
  </table>
  <div class="noDataRow"
       *ngIf="!listServingJoinServers || listServingJoinServers.length === 0">There is no data available</div>
</div>

<app-pagination-custom [config]="configPagerServingJoinServers"></app-pagination-custom>
